import { render } from "./ModalDeposit.vue?vue&type=template&id=55dff48a&scoped=true"
import script from "./ModalDeposit.vue?vue&type=script&lang=js"
export * from "./ModalDeposit.vue?vue&type=script&lang=js"

import "./ModalDeposit.vue?vue&type=style&index=0&id=55dff48a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dff48a"]])

export default __exports__